module.exports = __webpack_public_path__ + "img/MODULE.87ac5cf8.png";